import React, { useState } from 'react';
import { adminApi } from '../../repositories/admin';
import Swal from 'sweetalert2';
import  MultiSelect  from '../../PitchFormPage/components/MultiSelect/MultiSelect';

interface LabelModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AddLabelModal: React.FC<LabelModalProps> = ({ isOpen, onClose }) => {
  const [name, setName] = useState('');
  const [type, setType] = useState('');
  const [dsps, setDsps] = useState<string[]>([]);

  const musicPlatforms = [
    'Select All',
    'Spotify',
    'Apple Music', 
    'Deezer for Creators',
    'SoundCloud',
    'TIDAL',
    'Amazon Music',
    'Audiomack',
    'YouTube',
    'Email'
    
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      if (!name || !type || dsps.length === 0) {
        return Swal.fire('Error', 'Please fill in all fields', 'error');
      }
      const availableDSPs = dsps.filter((dsp) => dsp !== 'Select All');
      const response = await adminApi.addLabel({ name, type, availableDSPs });
      if (response?.data?.success) {
        Swal.fire('Success', 'Label added successfully!', 'success');
        setName('');
        setType('');
        setDsps([]);
        onClose();
      } else {
        Swal.fire('Error', response?.data?.message || 'Something went wrong', 'error');
      }
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'Error adding label', 'error');
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
      onClick={onClose} // clicking the background closes the modal
    >
      <div
        className="relative w-full max-w-md p-6 bg-white shadow-lg rounded-2xl"
        onClick={(e) => e.stopPropagation()} // prevent modal content click from closing
      >
        <h2 className="mb-6 text-2xl font-bold text-center text-gray-800">Add Company</h2>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">Company Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">Company Type</label>
            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select Type</option>
              <option value="independent">Independent Label</option>
              <option value="major">Major Label</option>
              <option value="management">Management</option>
              <option value="distributor">Distributor</option>
              <option value="music-services">Music Services</option>
            </select>
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">Available DSPs for this company</label>
            <MultiSelect value={dsps} onChange={setDsps} options={musicPlatforms} placeholder="Select DSPs" />
          </div>
          <button
            type="submit"
            className="w-full py-2 text-white transition duration-200 bg-blue-600 rounded-lg hover:bg-blue-700"
          >
            Add Company
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddLabelModal;